export const isPathActive = (item, pathname) => !!item.path && pathname === item.path;

export const hasActiveDescendant = (item, pathname) => {
  if (!item.children) return false;
  return item.children.some(
    (child) => isPathActive(child, pathname) || hasActiveDescendant(child, pathname),
  );
};

// Arrow-key nav between sibling menu items, plus in/out of a submenu.
export function handleMenuKeyDown(event, { hasChildren, isOpen, onOpen, onClose }) {
  const button = event.currentTarget;
  const list = button.closest('[role="menu"]');
  const siblings = list ? Array.from(list.querySelectorAll(':scope > li > [role="menuitem"]')) : [];
  const index = siblings.indexOf(button);

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault();
      siblings[index + 1]?.focus();
      break;
    case 'ArrowUp':
      event.preventDefault();
      siblings[index - 1]?.focus();
      break;
    case 'ArrowRight':
      if (hasChildren) {
        event.preventDefault();
        const focusFirstChild = () =>
          button.parentElement?.querySelector('[role="menu"] [role="menuitem"]')?.focus();
        if (isOpen) {
          focusFirstChild();
        } else {
          onOpen();
          // submenu isn't in the DOM yet, wait a frame for the re-render
          requestAnimationFrame(focusFirstChild);
        }
      }
      break;
    case 'ArrowLeft':
    case 'Escape':
      if (list && list.dataset.depth !== '0') {
        event.preventDefault();
        onClose?.();
        list.closest('li')?.querySelector('[role="menuitem"]')?.focus();
      }
      break;
    default:
      break;
  }
}
